import { FC } from 'react'
import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import styles from './ArticleCard.module.scss'
import { ArticleCardProps as Props } from '../types'
import Tag from 'components/tag/Tag'
import { useTranslation } from 'next-i18next'

const ArticleCard: FC<Props> = ({ article, destination }) => {
  // i18n
  const { t } = useTranslation('seo')

  return (
    <Link href={destination}>
      <a className={styles['article-card']}>
        <figure className={styles['thumbnail-wrapper']}>
          <Image
            layout="fill"
            src={article.thumbnail}
            alt={`${t('thumbnail', 'thumbnail')} ${article.title}`}
            objectFit="cover"
            className={styles.thumbnail}
          />
        </figure>
        <div className={styles.content}>
          {article.category && <Tag name={article.category?.title} color={article.category?.color} />}

          <h4 className={styles.title}>{article.title}</h4>

          <small className={styles.author}>
            {dayjs(article.publishedAt).format('DD/MM/YYYY')} | {article?.author?.firstName}
          </small>
        </div>
      </a>
    </Link>
  )
}

export default ArticleCard
